import axios from 'axios';
import { readStoredApiToken } from '../utils/apiToken';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
  headers: { 'Content-Type': 'application/json' },
});

/** Prefix for routes that require the user's opaque API token in the path. */
function withToken(suffix) {
  const token = readStoredApiToken();
  if (!token) return suffix;
  return `/${encodeURIComponent(token)}${suffix}`;
}

api.interceptors.request.use(
  (config) => {
    const token = readStoredApiToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const rulesAPI = {
  getDesignSpeeds: () => api.get('/rules/design-speeds'),
  updateDesignSpeed: (id, data) => api.put(`/rules/design-speeds/${id}`, data),
  createDesignSpeed: (data) => api.post('/rules/design-speeds', data),
  deleteDesignSpeed: (id) => api.delete(`/rules/design-speeds/${id}`),
  getLayoutConfig: () => api.get('/rules/layout-config'),
  updateLayoutConfig: (data) => api.put('/rules/layout-config', data),
  getXHeight: (speed) => api.get(`/rules/x-height?speed=${speed}`),
};

/** Saved / generated SVG library (MySQL saved_svgs) */
export const svgsAPI = {
  list: (page = 1, limit = 20) => api.get(`${withToken('/svgs')}?page=${page}&limit=${limit}`),
  get: (id) => api.get(`${withToken('/svgs')}/${id}`),
  create: (data) => api.post(withToken('/svgs'), data),
  update: (id, data) => api.put(`${withToken('/svgs')}/${id}`, data),
  delete: (id) => api.delete(`${withToken('/svgs')}/${id}`),
  getHistory: (id) => api.get(`${withToken('/svgs')}/${id}/history`),
};

/** @deprecated Use svgsAPI */
export const signsAPI = svgsAPI;

export const generateAPI = {
  generate: (data) => api.post(withToken('/generate'), data),
  /** Same Python pipeline — does not persist or count toward generation_limit */
  preview: (data) => api.post(withToken('/generate/preview'), data),
  getSignTypes: () => api.get('/generate/sign-types'),
};

export const statsAPI = {
  get: () => api.get(withToken('/stats')),
  getSvgCount: () => api.get(withToken('/svg-count')),
};

export default api;
